import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { DialogProvider } from "./components/ui";
import { I18nProvider } from "./lib/i18n";
import Editor from "./pages/Editor";
import Host from "./pages/Host";
import Landing from "./pages/Landing";
import Play from "./pages/Play";
import RoomEntry from "./pages/RoomEntry";
import Show from "./pages/Show";
import "./index.css";

// Every screen is addressed by room code, so a link, a QR, or a refresh all
// land in the same place. On Cloudflare that works via the Worker's SPA
// fallback; on GitHub Pages via the 404.html copy of index.html.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <I18nProvider>
      <DialogProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/new" element={<Editor />} />
            <Route path="/edit/:draftId" element={<Editor />} />
            <Route path="/r/:code" element={<RoomEntry />} />
            <Route path="/r/:code/admin" element={<Host />} />
            <Route path="/r/:code/show" element={<Show />} />
            <Route path="/r/:code/play" element={<Play />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </DialogProvider>
    </I18nProvider>
  </React.StrictMode>,
);
